// The Newsroom's nine house categories — each owns an accent, like real magazine sections.
export const CATEGORY_COLORS = {
  Money: "#1F5B43",
  Business: "#1F3A5F",
  Culture: "#7A2E2E",
  Style: "#6E3A5E",
  Trends: "#B45A21",
  Marketing: "#20666B",
  Workplace: "#4A5A7A",
  Community: "#8A6A1F",
  Success: "#A67C00",
};

// Lighter counterparts for text sitting on dark imagery.
export const CATEGORY_COLORS_BRIGHT = {
  Money: "#6FBF9A",
  Business: "#8FB3E0",
  Culture: "#E09A9A",
  Style: "#D49BC4",
  Trends: "#EDa06A",
  Marketing: "#7FCBD1",
  Workplace: "#AABDE0",
  Community: "#DDBB66",
  Success: "#E3C368",
};

export const categoryColor = (c) => CATEGORY_COLORS[c] || "#A67C00";
export const categoryColorBright = (c) => CATEGORY_COLORS_BRIGHT[c] || "#D9B64E";
